import React from 'react';
import clsx from 'clsx';
import { Container } from 'semantic-ui-react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { findError, validationClasses } from '@/utils/errors';
import fields from '@/constants/fields';
import ValidationSpan from '@/components/errors/ValidationSpan';
import MarkdownEditor from '@/components/text-editors/MarkdownEditor';
import HoverMarkdownContainer from '@/components/wrappers/HoverMarkdownContainer';
import { editCollection, updateCollectionProperties } from '../actions';
import { collectionPermissions } from '../sharing/constants';

const CollectionDescription = ({
  code,
  category,
  description,
  isEditing,
  canEdit,
  updateProperties,
  validationErrors,
  mobilePadding,
  showEdit,
}) => {
  if (!canEdit && !description) {
    return null;
  }

  const validationError = findError(validationErrors, 'collection', [fields.DESCRIPTION]);

  const updateDescription = (value) => (
    updateProperties(category, code, { description: value })
  );

  return (
    <Container fluid className={clsx('aridhia-collection-description', mobilePadding && 'mt-10')}>
      <ValidationSpan validationError={validationError} />
      {!isEditing && (
      <HoverMarkdownContainer
        canEdit={canEdit}
        showEdit={() => showEdit(category, code)}
        value={description}
        editText="click.to.edit.description"
        position="top"
        toolTip="bottom right"
        editCopyMods="field-container"
        as="h2"
        className="aridhia-collection-list-container aridhia-h3"
      />
      )}
      {canEdit && isEditing && (
        <MarkdownEditor
          value={description}
          className={validationClasses(
            validationError,
            'aridhia-collection-field-text-area aridhia-h3 aridhia-is-edit-mode min-h-135',
          )}
          maxEditorHeight={330}
          minPreviewHeight={80}
          onChange={updateDescription}
        />
      )}
    </Container>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { collections: { update } } } },
  collections: { collections },
}, { category, code }) => {
  const item = findResult(collections, category, code) || { isEditing: false, permissions: {} };

  return (
    {
      description: item.description,
      isEditing: item.isEditing,
      canEdit: update || (item.permissions[collectionPermissions.UPDATE]),
      validationErrors: item.saveErrors,
    }
  );
};

const mapDispatchToProps = {
  updateProperties: updateCollectionProperties,
  showEdit: editCollection,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDescription);
